import {gladlyAuthService} from '_services';
import {oauthConstants, alertMessages, toastMessage} from "_constants";
import {SnackBar} from "components/common";
import {history} from "_helpers";
import {Toast} from "../components/v3/common/Toast";

function verifyKey(params){
    function request() {
        return {type: oauthConstants.GLADLY_AUTH_REQUEST};
    }

    function success(payload) {
        return {type: oauthConstants.GLADLY_AUTH_SUCCESS, payload};
    }

    function failure() {
        return {type: oauthConstants.GLADLY_AUTH_FAILURE}
    }

    return (dispatch) => {
        dispatch(request());

        gladlyAuthService.verifyApiKey(params)
            .then(
                (res) => {
                    dispatch(success(res));
                    history.push('/company/channels')
                    const {successMessage, options} = toastMessage.connectChannel;
                    Toast.showMessage(successMessage, options);
                },
                (error) => {
                    dispatch(failure(error));
                    SnackBar.showMessage(alertMessages.GLADLY_AUTH_FAILURE)
                },
            );
    };
}

function getInboxes(params){
    function request() {
        return {type: oauthConstants.GLADLY_INBOX_REQUEST};
    }

    function success(payload) {
        return {type: oauthConstants.GLADLY_INBOX_SUCCESS, payload};
    }

    function failure() {
        return {type: oauthConstants.GLADLY_INBOX_FAILURE}
    }

    return (dispatch) => {
        dispatch(request());

        gladlyAuthService.getInboxes(params)
            .then(
                (res) => {
                    dispatch(success(res));
                },
                (error) => {
                    dispatch(failure(error));
                },
            );
    };
}

export const gladlyAuthActions = {
    verifyKey,
    getInboxes
}
